module.exports = __webpack_public_path__ + "img/RBIES.4df9bc49.svg";